var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"avatasakaIndex"}},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"appContent"},[_c('router-view')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('back-to-top',{attrs:{"bottom":"50px","right":"0px"}},[_c('button',{staticClass:"btn btn-info btn-to-top",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9818456c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Avatamsaka.vue
// module id = null
// module chunks = 